import { isString } from "lodash-es";
import { matchPath, useLocation } from "react-router";

export const useAnyActivePath = (...urls) => {
  const { pathname } = useLocation();

  return urls.some((url) => {
    if (!url || !isString(url)) return false;
    return matchPath({ path: url, end: true }, pathname);
  });
};
